import React from "react";

export function LogoMark({ size = 28, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="dex-g" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="1" stopColor="#7C3AED" />
        </linearGradient>
      </defs>
      {/* Prism / router mark: two interlocking arrows forming an X */}
      <rect x="1" y="1" width="30" height="30" rx="9" fill="url(#dex-g)" />
      <path
        d="M9 12 h9 M18 12 L15 9 M18 12 L15 15"
        stroke="#FFFFFF"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M23 20 H14 M14 20 L17 17 M14 20 L17 23"
        stroke="#FFFFFF"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function LogoWordmark({ size = 28 }) {
  return (
    <div className="inline-flex items-center gap-2.5">
      <LogoMark size={size} />
      <span className="flex items-baseline gap-1.5 leading-none">
        <span className="text-[15px] sm:text-[16px] font-extrabold tracking-[-0.02em] text-[var(--text)]">
          DEX
        </span>
        <span className="text-[15px] sm:text-[16px] font-medium tracking-[-0.01em] text-[var(--accent)]">
          Router
        </span>
      </span>
    </div>
  );
}

export default LogoMark;
